import { useContext, useEffect, useMemo } from 'react';
import { LayoutContext, Mode } from '@bingads-webui-react/app-layout-container';
import { PaymentContext } from '@bingads-webui-cc-react/payment-context';

import { usePromotionBannerContext } from './promotion-banner-context';

// Promotion banner hook used by coupon banner view.
// Since promotion banner is part of the Top level Banner layout, this hook
// controls the promotionBanner layout mode (hidden/expanded) property based
// on coupon availability as well as manual suppress context flag(isHidePromotionBanner)
export function usePromotionBannerState() {
  const { config, change: changeLayout } = useContext(LayoutContext);
  const { paymentContext: { cco, ccl } } = useContext(PaymentContext);
  const { isHidePromotionBanner, bannerInfo } = usePromotionBannerContext();

  const hasPromotion = !!(cco || ccl || bannerInfo);

  const shouldShowBanner = useMemo(() => {
    const { promotionBanner: { mode } } = config;
    return (hasPromotion && (mode === Mode.Expanded) && !isHidePromotionBanner);
  }, [config, hasPromotion, isHidePromotionBanner]);

  useEffect(() => {
    const { promotionBanner: { mode } } = config;
    if (!hasPromotion && mode === Mode.Expanded) {
      changeLayout({ promotionBanner: { mode: Mode.Hidden } });
    } else if (hasPromotion) {
      if (mode !== Mode.Expanded && !isHidePromotionBanner) {
        changeLayout({ promotionBanner: { mode: Mode.Expanded } });
      } else if (mode === Mode.Expanded && isHidePromotionBanner) {
        changeLayout({ promotionBanner: { mode: Mode.Hidden } });
      }
    }
  }, [changeLayout, config, hasPromotion, isHidePromotionBanner]);

  return [{
    bannerInfo,
    shouldShowBanner,
  }];
}
